import { createContext, useContext, useMemo, useState } from 'react'
import type {
  DashboardSearchContextValue,
  DashboardSearchProviderProps,
} from './DashboardSearchContext.types'

const DashboardSearchContext = createContext<
  DashboardSearchContextValue | undefined
>(undefined)

export function DashboardSearchProvider({
  children,
}: DashboardSearchProviderProps) {
  const [searchQuery, setSearchQuery] = useState('')
  const value = useMemo(() => ({ searchQuery, setSearchQuery }), [searchQuery])

  return (
    <DashboardSearchContext.Provider value={value}>
      {children}
    </DashboardSearchContext.Provider>
  )
}

export function useDashboardSearch(): DashboardSearchContextValue {
  const context = useContext(DashboardSearchContext)

  if (!context) {
    throw new Error(
      'useDashboardSearch must be used within a DashboardSearchProvider.'
    )
  }

  return context
}
